"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixPromoTitle = exports.formatBeverlyWilshire = void 0;
const formatBeverlyWilshire = (text) => {
    if (!text) {
        return '';
    }
    let formattedText = '';
    try {
        formattedText = text.replace(/(beverly wilshire,) (a four seasons hotel)/gi, "$1 <span class='font-20'>$2</span>");
    }
    catch (e) {
        formattedText = text;
    }
    return formattedText;
};
exports.formatBeverlyWilshire = formatBeverlyWilshire;
const fixPromoTitle = (titleIn) => {
    if (!titleIn) {
        return titleIn;
    }
    const split = titleIn.length / 2;
    const start = titleIn.substring(0, split);
    const end = titleIn.substring(split);
    if (end.toLowerCase().includes(start.toLowerCase())) {
        return start.trim();
    }
    return titleIn.replace(/[.\s]+$/, '');
};
exports.fixPromoTitle = fixPromoTitle;
